import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {ProductService} from "../../services/product.service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'product',
    templateUrl: './product.component.html'
})
export class ProductComponent implements OnInit {
    private id: string = null;

    public product: Object = null;
    public scoreTooltipText: string = 'De ingrediënten staan altijd op de verpakking met het hoogste geconcentreerde ingrediënt bovenaan en het kleinst geconcentreerde ingrediënt als laatste. De fabrikanten hoeven niet de exacte hoeveelheid en/of concentratiegehalte op de verpakking te zetten. Aangezien het niet mogelijk is om de exacte concentratie van de ingrediënten te achterhalen, is het gemiddelde van de waardering van de ingrediënten genomen. Dat bepaalt de score van het product. De score van het product is dus slechts een indicatie!';
    public showAllAnswers: boolean = false;

    public showIngredients: boolean = true;
    public showSpecifications: boolean = false;

    constructor(private titleService: Title, private productService: ProductService, private route: ActivatedRoute, private router: Router) { }

    ngOnInit() {
        this.product = null;
        this.titleService.setTitle('Dermabase - Product details');
        this.route.params.subscribe(params => {
            this.id = params['id'];

            this.productService.get(this.id).subscribe((res) => {
                if(res['data'] && res['data'].length >= 1)
                {
                    this.product = res['data'][0];
                    this.product['price'] = parseFloat(this.product['Prijs'].replace(',', '.'));
                    this.product['price'] = this.product['price'].toFixed(2);
                    this.product['price'] = this.product['price'].replace('.', ',');
                    console.log("This is a custom directive!");
                    //TODO: add tested clause
                    //this.product['tested'] =

                    this.titleService.setTitle(this.product['Merk'] + ' ' + this.product['Subnaam'] + ' - Dermabase');
                }
            });
        });
    }

    showIngredient() {
        this.showIngredients = true;
        this.showSpecifications = false;
        document.getElementById("ingredients").classList.add('active');
        document.getElementById("specifications").classList.remove('active');
    }

    showSpecification() {
        this.showIngredients = false;
        this.showSpecifications = true;
        document.getElementById("ingredients").classList.remove('active');
        document.getElementById("specifications").classList.add('active');
    }

}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/product/product.component.ts